// extracted by mini-css-extract-plugin
export default {"logow":"whatapp_logow__0bUVl","floatAnimation":"whatapp_floatAnimation__jdddl"};